<template>
    <div class="marker community-marker" @click="onClick"></div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
    name: "CommunityMarker",
    props: {
        id: {
            type: Number,
            required: true,
        },
    },
    methods: {
        onClick(e): void {
            this.$emit("marker-click", { id: this.id });
            e.stopPropagation();
        },
    },
});
</script>

<style scoped lang="scss">
.community-marker {
    height: 9px;
    width: 9px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    cursor: pointer;
    background-color: #5c6bc0;
    border-radius: 2px;
    transform: rotate(45deg);
}
</style>
